(function () {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  let menuButton;

  function updateMobileMenuOffset() {
    const header = document.querySelector('.top-outer');
    if (!header) return;

    document.documentElement.style.setProperty(
      '--mobile-header-height',
      `${header.offsetHeight}px`
    );
  }

  function handleMenuClick(event) {
    const shopMenu = event.target.closest('.shopmenu');
    if (shopMenu) {
      shopMenu.closest('.mobilemenubody')?.classList.toggle('activenavmain');
      return;
    }

    const mobileDropdownLink = event.target.closest(
      '.mobiledropmenu .navbar-nav > li > a'
    );
    if (
      mobileDropdownLink?.parentElement?.querySelector(
        ':scope > .dropdown-toggle'
      )
    ) {
      event.preventDefault();
      mobileDropdownLink.parentElement.classList.toggle('activenav');
      return;
    }

    const dropdownToggle = event.target.closest('.dropdown-toggle');
    if (dropdownToggle) {
      dropdownToggle.parentElement?.classList.toggle('activenav');
    }
  }

  function getMenuFocusables(mobileMenu) {
    return Array.from(mobileMenu.querySelectorAll?.(focusableSelector) || []);
  }

  function setMenuOpen(mobileMenu, button, isOpen) {
    mobileMenu.classList.toggle('active', isOpen);
    mobileMenu.setAttribute?.('aria-hidden', String(!isOpen));
    document.documentElement.classList.toggle('bodyclass', isOpen);
    button?.classList.toggle('open', isOpen);
    button?.setAttribute?.('aria-expanded', String(isOpen));
    button?.setAttribute?.('aria-label', isOpen ? 'Close menu' : 'Open menu');

    if (isOpen) {
      const firstFocusable = getMenuFocusables(mobileMenu)[0] || mobileMenu;
      const moveFocus = () => firstFocusable.focus?.();
      if (window.requestAnimationFrame) window.requestAnimationFrame(moveFocus);
      else moveFocus();
      return;
    }

    window.dispatchEvent(new CustomEvent('mobile-search-reset'));
    button?.focus?.();
  }

  window.toggleSidebar = function (button) {
    const mobileMenu = document.getElementById('sidemenunew');
    if (!mobileMenu) return;

    setMenuOpen(mobileMenu, button || menuButton, !mobileMenu.classList.contains('active'));
  };

  function handleMenuKeydown(event) {
    const mobileMenu = document.getElementById('sidemenunew');
    if (!mobileMenu?.classList.contains('active')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      setMenuOpen(mobileMenu, menuButton, false);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusables = getMenuFocusables(mobileMenu);
    if (!focusables.length) {
      event.preventDefault();
      mobileMenu.focus?.();
      return;
    }

    const firstFocusable = focusables[0];
    const lastFocusable = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  }

  function initHeader() {
    menuButton = document.getElementById('nav-icon4');
    menuButton?.addEventListener('click', () => window.toggleSidebar(menuButton));
    document.addEventListener('click', handleMenuClick);
    document.addEventListener('keydown', handleMenuKeydown);
    window.addEventListener('resize', updateMobileMenuOffset, { passive: true });
    updateMobileMenuOffset();

    const header = document.querySelector('.top-outer');
    if (header && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateMobileMenuOffset).observe(header);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader, { once: true });
  } else {
    initHeader();
  }
})();
